import Table from "../../../../contents/_includes/example-table.mdx";
import { ComparisonTable } from 'components/ComparisonTable';
import { ComparisonRow } from 'components/ComparisonTable/row';
import { ComparisonHeader } from 'components/ComparisonTable/header';
import * as React from 'react';
export default {
  Table,
  ComparisonTable,
  ComparisonRow,
  ComparisonHeader,
  React
};